<template>
  <div>
    <div v-if="label" class="subtitle-2 button-group-label">
      {{ label }}
      <tooltip v-if="!hideTooltip" :text="tooltip" />
      <helpIcon v-if="helpContent" :content="helpContent" />
    </div>
    <buttonGroup :value="getGroupValue" @change="[setConfigValue($event)]">
      <qvoButton v-for="option in options" :key="option.Value">
        {{ option.Display }}
      </qvoButton>
    </buttonGroup>
  </div>
</template>

<script>
/**
 * @fileoverview Config input field for button group inputs
 *
 * @author Cameron Bulock <cameron.bulock@quavo.com>
 */

import qvoButton from "@/qux-common/qux22/components/molecules/button";
import buttonGroup from "@/qux-common/qux22/components/molecules/button-group";

import tooltip from "@/components/tooltip";

import fieldMap from "./field-map.json";

export default {
  name: "ButtonGroupField",
  components: { qvoButton, buttonGroup, tooltip },
  props: {
    category: {
      type: String,
    },
    helpContent: {
      type: String,
    },
    hideTooltip: {
      type: Boolean,
    },
    id: {
      type: String,
    },
    label: {
      type: String,
    },
    options: {
      type: Array,
    },
    tooltip: {
      type: String,
    },
    value: {
      type: [String, Boolean],
    },
    parentField: {
      type: String,
    },
  },
  methods: {
    /**
     * Sets the value
     */
    setConfigValue(value) {
      this.$emit("setConfigValue", this.options[value]["Value"]);
    },
    getFieldValue(value) {
      return (
        fieldMap[this.category] &&
        fieldMap[this.category][this.id] &&
        fieldMap[this.category][this.id][value]
      );
    },
  },
  computed: {
    getGroupValue() {
      return this.options.findIndex((option) => option.Value === this.value);
    },
  },
};
</script>

<style lang="scss" scoped>
.v-input {
  &::v-deep {
    .radio-fields {
      display: flex;
      flex-direction: row;
      align-items: baseline;
    }
    .v-radio {
      margin-right: 1em;
    }
  }
}
.button-group-label {
  display: flex;
  align-items: center;
  gap: $qvo-spacing-8; 
  margin-bottom: $input-label-spacing;
}
</style>